import {Tabs} from 'antd'
import {feed_fetchFeedByContainer_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import EmptyHolder from 'components/EmptyHolder'
import Pure from 'components/Pure'
import {useQueryString} from 'hooks'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {NavigationContext} from 'modules/navigation/NavigationContext'
import {permissionCodes} from 'modules/permissions/contants'
import PermissionProvider from 'modules/permissions/PermissionProvider'
import React, {useContext, useMemo} from 'react'
import {useLocation} from 'react-router-dom'
import {nest} from 'recompose'
import {feedContentTypes} from 'views/Feed/Feed'
import EntityList from 'views/AppLocals/EntityList'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault} from 'views/Shared'
import {renderFeedByType} from '../../../MainPage/functions/renderFeedItem'
import OrganizationContainerContext from '../OrganizationContainerContext'
import {getRouteSearchParams} from '../../../../envs/_current/history'
import GeneralPostForm from '../../../../components/Feed/PostForm/GenericPostForm'

const OrganizationNews = ({ Wrapper = 'div', sample, Footer = NullAsDefault }) => {
    const t = useTranslate()
    const location = useLocation()
    const [queryString] = useQueryString()
    const content_type = _.get(queryString, 'content-type')
    const { organization } = useContext(OrganizationContainerContext)

    const [id, prop] = [getId(organization), getType(organization)]
    const apiInfo = feed_fetchFeedByContainer_Api

    const refreshKey = useMemo(
        () => [
            apiInfo.path.replace(':id', id).replace(':prop', prop),
            content_type,
            `refreshToken=${location?.state?.refreshToken}`,
        ].join('/'),
        [id, prop, apiInfo, content_type, location?.state]
    )

    if (_.isEmpty(organization)) return null

    const { available_actions } = organization

    return (
        <Wrapper className="space-y-3">
            {!sample && (
                <PermissionProvider
                    permissions={{
                        [permissionCodes.canPost]: _.get(available_actions, permissionCodes.canPost),
                    }}>
                    <GeneralPostForm
                        container={{ type: getType(organization), id: getId(organization) }}
                        defaultChannel={organization?.default_channel}
                    />
                </PermissionProvider>
            )}

            <NavigationContext.Consumer>
                {({ history }) => (
                    <Tabs
                        className="tab-news-inner"
                        activeKey={content_type}
                        tabBarStyle={{ margin: 0 }}
                        destroyOnHidden={true}
                        onChange={(activeKey) => {
                            const searchParams = getRouteSearchParams()
                            searchParams.set('content-type', activeKey)
                            history.push({ search: '?' + searchParams.toString() })
                        }}
                        items={feedContentTypes.map(({ label, value }) => ({
                            key: value,
                            label: <span className="space-x-1">{t(label)}</span>,
                        }))}
                    />
                )}
            </NavigationContext.Consumer>

            <Pure input={[id, prop, content_type, refreshKey]}>
                <EntityList
                    sample={sample}
                    key={refreshKey}
                    values={{ content_type }}
                    apiInfo={apiInfo}
                    query={bindQueryParams([{ id }, { prop }])}
                    renderItem={renderFeedByType(content_type || 'all')}
                    renderEmpty={() => (
                        <div className="w-full justify-center items-center">
                            <EmptyHolder />
                        </div>
                    )}
                    renderWrap={(child, __, count) => (
                        <div className="space-y-3">
                            {child}
                            {count ? <Footer /> : null}
                        </div>
                    )}
                />
            </Pure>
        </Wrapper>
    )
}

export default nest(Pure, OrganizationNews)